var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 35.9997C72 42.4234 66.6562 47.6322 60.0638 47.6322C53.4712 47.6322 48.1275 42.4234 48.1275 35.9997C48.1275 29.5759 53.4712 24.3672 60.0638 24.3672C66.6562 24.3672 72 29.5759 72 35.9997ZM8.2125 43.7059H4.10625C1.83375 43.7059 0 41.8722 0 39.5997V32.3997C0 30.1384 1.83375 28.2934 4.10625 28.2934H8.2125V43.7059Z",
    fill: "#129BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2027 52.6713H17.5039V49.9375H19.2027C19.4502 49.9375 19.6527 50.14 19.6527 50.3875V52.2325C19.6527 52.4688 19.4502 52.6713 19.2027 52.6713Z",
    fill: "#C5E7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1983 65.5534C12.0158 65.5534 10.2383 63.7872 10.2383 61.5934V43.7734H18.147V61.6047C18.1583 63.7872 16.3808 65.5534 14.1983 65.5534Z",
    fill: "#129BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42531 47.6097L27.2128 47.6209V24.3672H8.44781C6.58031 24.3672 5.06156 25.8409 5.06156 27.6522L5.03906 44.3022C5.03906 46.1359 6.55781 47.6097 8.42531 47.6097Z",
    fill: "#C5E7FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3658 63.8006L25.8633 47.6344V24.3694L59.3658 8.20312V63.8006Z",
    fill: "#129BFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0655 66.8366C58.3442 66.8366 56.9492 65.4753 56.9492 63.7991V8.20156C56.9492 6.52531 58.3442 5.16406 60.0655 5.16406C61.7867 5.16406 63.1817 6.52531 63.1817 8.20156V63.8103C63.1817 65.4753 61.7867 66.8366 60.0655 66.8366Z",
    fill: "#C5E7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.5ce86ee9f8778c2cf12a68b64e737855.svg";
export { ForwardRef as ReactComponent };